import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import {
  cancelInvoiceDevolutionSolicitation, getInvoiceDevolutionDetails,
} from '../app/store/actions/invoiceDevolution';
import PriceComponent from '../components/price/Price';
import INVOICE_DEVOLUTIONS from '../data/invoiceDevolution';

class InvoiceDevolutionDetailsPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showCancelationModal: false,
      showCancelationResponseErrorMessage: false,
      showCancelationResponseSuccessMessage: false,
      cancelationResponseMessage: '',
      productsInformationList: [],
      cancelSolicitationButtonLabel: '',
    };
  }

  componentDidMount = () => {
    setTimeout(async () => {
      const { nciNumber, devolutionNumber } = this.props.location.state;

      await this.props.getInvoiceDevolutionDetails(nciNumber, devolutionNumber);

      if (this.props.invoiceDevolutionDetails && Object.keys(this.props.invoiceDevolutionDetails).length) {
        await this.setState({
          cancelSolicitationButtonLabel: this.props.invoiceDevolutionDetails.sphereNCI.statusCheckbuy,
        });

        if (this.props.invoiceDevolutionDetails.devolutionProductList) {
          await this.setProductsInformationList(this.props.invoiceDevolutionDetails.devolutionProductList);
        }
      }
    }, 0);
  }

  setProductsInformationList = async (productList) => {
    const productsInformationList = [];
    for (let index = 0; index < Object.keys(productList).length; index += 1) {
      productsInformationList.push(Object.values(productList)[index]);
    }

    await this.setState({ productsInformationList });
  }

  renderTracking = (invoiceDevolutionDetails) => {
    if (invoiceDevolutionDetails.sphereNCI.statusCheckbuy === INVOICE_DEVOLUTIONS.types[5].label) {
      return (
        <div className="panel-timeline">
          <div className="step active">
            <div className="step-line" />
            <div className="step-number">1</div>
            {I18n.t('openSolicitation')}
            <svg className="icon icon-copy-solid">
              <use xlinkHref="#icon-copy-solid" />
            </svg>
          </div>
          <div className="step active">
            <div className="step-line" />
            <div className="step-number">2</div>
            {I18n.t('pendingSolicitation')}
            <svg className="icon icon-copy-solid">
              <use xlinkHref="#icon-copy-solid" />
            </svg>
          </div>
          <div className="step active">
            <div className="step-line" />
            <div className="step-number">3</div>
            <div style={{ color: 'red' }}>
              {I18n.t('cancelledSolicitation')}
              <svg className="icon icon-times-circle-solid" style={{ fill: 'red' }}>
                <use xlinkHref="#icon-times-circle-solid" />
              </svg>
            </div>
          </div>
        </div>
      );
    }

    if (invoiceDevolutionDetails.sphereNCI.statusCheckbuy === INVOICE_DEVOLUTIONS.types[3].label) {
      return (
        <div className="panel-timeline">
          <div className="step active">
            <div className="step-line" />
            <div className="step-number">1</div>
            {I18n.t('openSolicitation')}
            <svg className="icon icon-copy-solid">
              <use xlinkHref="#icon-copy-solid" />
            </svg>
          </div>
          <div className="step active">
            <div className="step-line" />
            <div className="step-number">2</div>
            {I18n.t('pendingSolicitation')}
            <svg className="icon icon-copy-solid">
              <use xlinkHref="#icon-copy-solid" />
            </svg>
          </div>
          <div className="step active">
            <div className="step-line" />
            <div className="step-number">3</div>
            {I18n.t('approvedSolicitation')}
            <svg className="icon icon-clipboard-check-solid">
              <use xlinkHref="#icon-clipboard-check-solid" />
            </svg>
          </div>
          <div className="step active">
            <div className="step-line" />
            <div className="step-number">4</div>
            <div style={{ color: 'red' }}>
              {I18n.t('rejectSolicitation')}
              <svg className="icon icon-times-circle-solid" style={{ fill: 'red' }}>
                <use xlinkHref="#icon-times-circle-solid" />
              </svg>
            </div>
          </div>
        </div>
      );
    }

    let step = 0;

    if (invoiceDevolutionDetails.sphereNCI.statusCheckbuy === INVOICE_DEVOLUTIONS.types[1].label) step = 1;
    if (invoiceDevolutionDetails.sphereNCI.statusCheckbuy === INVOICE_DEVOLUTIONS.types[2].label) step = 2;
    if (invoiceDevolutionDetails.sphereNCI.statusCheckbuy === INVOICE_DEVOLUTIONS.types[4].label) step = 3;

    return (
      <div className="panel-timeline">
        <div className={step >= 0 ? 'step active' : 'step'}>
          <div className="step-line" />
          <div className="step-number">1</div>
          {I18n.t('openSolicitation')}
          <svg className="icon icon-copy-solid">
            <use xlinkHref="#icon-copy-solid" />
          </svg>
        </div>
        <div className={step >= 1 ? 'step active' : 'step'}>
          <div className="step-line" />
          <div className="step-number">2</div>
          {I18n.t('pendingSolicitation')}
          <svg className="icon icon-copy-solid">
            <use xlinkHref="#icon-copy-solid" />
          </svg>
        </div>
        <div className={step >= 2 ? 'step active' : 'step'}>
          <div className="step-line" />
          <div className="step-number">3</div>
          {I18n.t('approvedSolicitation')}
          <svg className="icon icon-clipboard-check-solid">
            <use xlinkHref="#icon-clipboard-check-solid" />
          </svg>
        </div>
        <div className={step >= 3 ? 'step active' : 'step'}>
          <div className="step-line" />
          <div className="step-number">4</div>
          {I18n.t('finalizedSolicitation')}
          <svg className="icon icon-check-circle-solid">
            <use xlinkHref="#icon-check-circle-solid" />
          </svg>
        </div>
      </div>
    );
  }

  renderCancelationModal = (cancelationModal, invoiceDevolutionDetails) => (
    <div
      role="presentation"
      className="modal"
      style={{ display: cancelationModal ? 'block' : 'none' }}
      onClick={() => this.setState({ showCancelationModal: false })}
    >
      <div className="modal-content">
        <div className="modal-body">
          <div className="column body-modal-text" style={{ textAlign: 'justify' }}>
            <h3 className="h3-modal-div">
              {I18n.t('cancelInvoiceDevolutionWarning', { 0: invoiceDevolutionDetails.sphereNCI.id })}
            </h3>
            <h4 className="h4-modal-div">{I18n.t('cancelInvoiceDevolutionWarning2')}</h4>
          </div>
          <div className="row body-modal-div">
            <button
              type="button"
              className="btn"
              onClick={() => this.setState({ showCancelationModal: false })}
            >
              {I18n.t('no')}
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => this.cancelSolicitation()}
            >
              {I18n.t('yes')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )

  cancelSolicitation = async () => {
    const { invoiceDevolutionDetails } = this.props;

    this.setState({ showCancelationModal: false });

    try {
      const result = await this.props.cancelSolicitation({
        cod_nci: invoiceDevolutionDetails.sphereDevolutionId,
        nota_fiscal: invoiceDevolutionDetails.purchaseInvoiceNumber,
        cod_cliente: String(invoiceDevolutionDetails.purchaseInvoice.invoicesPurchases.clientId),
      });

      if (result && result.success) {
        await this.setState({
          showCancelationResponseErrorMessage: false,
          showCancelationResponseSuccessMessage: true,
          cancelationResponseMessage: result.response
            ? result.response
            : I18n.t('invoiceDevolutionCancelledSuccessfully'),
        });
      } else {
        await this.setState({
          showCancelationResponseErrorMessage: true,
          showCancelationResponseSuccessMessage: false,
          cancelationResponseMessage: I18n.t('notPossibleToCancelThisSolicitation'),
        });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data.error && error.response.data.error.code === 1706) {
          await this.setState({
            showCancelationResponseErrorMessage: true,
            showCancelationResponseSuccessMessage: false,
            cancelationResponseMessage: I18n.t('NCINumberNotFound'),
          });
        } else if (error.response.data.error && error.response.data.error.code === 1700) {
          await this.setState({
            showCancelationResponseErrorMessage: true,
            showCancelationResponseSuccessMessage: false,
            cancelationResponseMessage: I18n.t('salesInvoiceNumberNotFound'),
          });
        } else if (error.response.data.error && error.response.data.error.code === 500) {
          await this.setState({
            showCancelationResponseErrorMessage: true,
            showCancelationResponseSuccessMessage: false,
            cancelationResponseMessage: I18n.t('clientCodeNotFound'),
          });
        } else {
          await this.setState({
            showCancelationResponseErrorMessage: true,
            showCancelationResponseSuccessMessage: false,
            cancelationResponseMessage: I18n.t('notPossibleToCancelThisSolicitation'),
          });
        }
      }
    }
  }

  renderTotalValue = (productList) => {
    let totalValue = 0;
    for (let index = 0; index < Object.keys(productList).length; index += 1) {
      totalValue += Object.values(productList)[index].totalValue;
    }

    return <PriceComponent value={totalValue} /> || '';
  }

  render() {
    const { invoiceDevolutionDetails } = this.props;

    const {
      showCancelationModal, cancelationResponseMessage,
      showCancelationResponseErrorMessage, showCancelationResponseSuccessMessage,
      productsInformationList, cancelSolicitationButtonLabel,
    } = this.state;

    if (!invoiceDevolutionDetails || !Object.keys(invoiceDevolutionDetails).length) {
      return (
        <div className="nci-error-message">
          <p className="nci-error-message-text">{I18n.t('notShowNCIDetails')}</p>
        </div>
      );
    }

    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <h1 className="panel-title">{I18n.t('NCIDetails')}</h1>
            {this.renderTracking(invoiceDevolutionDetails)}
            <div className="panel-content" style={{ margin: '0 0 40px 0' }}>
              <div className="box box-50">
                <h2 className="box-title"><span>{I18n.t('details2')}</span></h2>
                <div>
                  <p>{`${I18n.t('nciCode')}${invoiceDevolutionDetails.sphereDevolutionId}`}</p>
                  <p>{`${I18n.t('invoiceDevolutionNumber')}${invoiceDevolutionDetails.sphereNCI.invoiceDevolution || ''}`}</p>
                  <p>{`${I18n.t('invoiceDevolutionReasonForOpening')}${invoiceDevolutionDetails.sphereNCI.sphereReason.description}`}</p>
                  <p>{`${I18n.t('requestingUser')}${invoiceDevolutionDetails.purchaseInvoice.invoicesPurchases.user.email}`}</p>
                  <p>{`${I18n.t('dateOfDevolution')}${moment(invoiceDevolutionDetails.createdAt).format('LLL')}`}</p>
                </div>
              </div>
              <div className="box box-b-bottom">
                <h2 className="box-title"><span>{I18n.t('products2')}</span></h2>
                {productsInformationList && productsInformationList.length > 0 && (
                  productsInformationList.map((element, index) => (
                    <React.Fragment key={element.code}>
                      {index > 0 && (
                        <div style={{ borderBottom: '1px solid #7C7E83', marginTop: 4, marginBottom: 10 }} />
                      )}
                      <p>{element.description}</p>
                      <ul>
                        <li>{`${I18n.t('invoiceDevolutionProductCode')}${element.code}`}</li>
                        <li>
                          {`${I18n.t('invoiceDevolutionQuantity')}${element.quantity || ''}`}
                          <span>
                            <span>{I18n.t('invoiceDevolutionPrice')}</span>
                            <PriceComponent value={element.totalValue || ''} />
                          </span>
                        </li>
                      </ul>
                    </React.Fragment>
                  )))}
              </div>
              <div className="box">
                <h2 className="box-title"><span>{I18n.t('totalValue')}</span></h2>
                <ul>
                  <li>
                    <span>{I18n.t('total2')}</span>
                    {invoiceDevolutionDetails && invoiceDevolutionDetails.devolutionProductList && (
                      <span>{this.renderTotalValue(invoiceDevolutionDetails.devolutionProductList)}</span>
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <button
              type="button"
              className={
                invoiceDevolutionDetails.sphereNCI.statusCheckbuy !== 'pending'
                  ? 'btn cursorPointer nci-cancel-button'
                  : 'btn cursorPointer'
                }
              style={{ margin: '0 auto' }}
              disabled={cancelSolicitationButtonLabel !== 'pending'}
              onClick={(event) => {
                event.preventDefault();
                this.setState({ showCancelationModal: true });
              }}
            >
              {I18n.t('cancelInvoiceDevolution')}
            </button>
            {showCancelationResponseErrorMessage && (
              <p className="error-msg" style={{ margin: '45px 0 0 0' }}>{cancelationResponseMessage}</p>
            )}
            {showCancelationResponseSuccessMessage && (
              <p className="success-msg" style={{ margin: '45px 0 0 0' }}>{cancelationResponseMessage}</p>
            )}
            {this.renderCancelationModal(showCancelationModal, invoiceDevolutionDetails)}
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  invoiceDevolutionDetails: state.invoiceDevolution.invoiceDevolutionDetails,
});

const mapDispatchToState = dispatch => ({
  getInvoiceDevolutionDetails: (nciNumber, devolutionNumber) => dispatch(
    getInvoiceDevolutionDetails(nciNumber, devolutionNumber),
  ),
  cancelSolicitation: data => dispatch(
    cancelInvoiceDevolutionSolicitation(data),
  ),
});

export default connect(mapStateToProps, mapDispatchToState)(InvoiceDevolutionDetailsPage);
